(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/views/betslip/betslip-overview.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/views/betslip/betslip-overview.js'); 'use strict';

svs.maltipset.views.BetslipOverview = Backbone.Marionette.View.extend({
  className: 'maltipset-betslip-content',
  regions: {
    rows: '.rows'
  },
  events: {
    'click @ui.closeBtn': 'hideOddsFolder'
  },
  ui: {
    closeBtn: '.js-close-odds-folder'
  },
  template: function template(data) {
    return svs.maltipset.templates.betslip_overview(data);
  },
  initialize: function initialize() {
    this.onAccountChange = this.onAccountChange.bind(this);
    if (svs.components.marketplace && svs.components.marketplace.accountSelector.helpers.observer.subscribe(this.onAccountChange)) ;
  },
  onAccountChange: function onAccountChange(_ref) {
    var currentAccount = _ref.currentAccount;

    if (currentAccount) {
      this.options.coupon.updateNumWeeks(1);
      if (this.getRegion('weeks')) this.getRegion('weeks').empty();

      if (!svs.core.detect.feature('ft-marketplace-sportkryss') && this.getRegion('sportkryss')) {
        this.getRegion('sportkryss').empty();
      }

      this.options.betslip.doResize();
    } else {
      if (this.getRegion('weeks')) {
        this.getRegion('weeks').show(new svs.maltipset.views.BetslipContentWeeks({
          model: new svs.maltipset.models.Betslip({
            coupon: this.options.coupon
          })
        }));
      }

      if (!svs.core.detect.feature('ft-marketplace-sportkryss') && this.getRegion('sportkryss')) {
        var self = this;
        this.getRegion('sportkryss').show(new svs.sport.sportkryss.Sportkryss({
          model: this.options.coupon.get('hasSportkryssBet') ? this.options.coupon.get('sportkryssBet') : null,
          onSportkryssChanged: function onSportkryssChanged(bet) {
            self.options.coupon.updateSportkryss(bet);
          },
          toggleButtonCSSClass: 'sportkryss-btn-maltipset',
          helpDialogTitle: svs.maltipset.data.config.helpTexts.sportkryss.title,
          helpDialogBody: svs.maltipset.data.config.helpTexts.sportkryss.body
        }));
      }

      this.options.betslip.doResize();
    }
  },
  hideOddsFolder: function hideOddsFolder() {
    this.dimmer.removeClass('maltipset-betslipoverview-dimmer-visible');
    this.$el.parent().removeClass('maltipset-slider-folder-open');
    var textSpan = $('#betslip-overview').find('span');
    textSpan.text(textSpan.text() === 'Visa översikt av spelet' ? 'Dölj översikt av spelet' : 'Visa översikt av spelet');
  },
  onRender: function onRender() {
    this.getRegion('rows').show(new svs.maltipset.views.BetslipContentRows({
      model: new svs.maltipset.models.Betslip({
        coupon: this.options.coupon
      }),
      betslip: this.options.betslip
    }));
    this.dimmer = this.dimmer || $('.maltipset-betslipoverview-dimmer');
    this.dimmer.on('click', this.hideOddsFolder.bind(this));
  }
});
 })(window);